import React, { useEffect } from "react";
import Select from "react-select";

import { InputLabel } from "../Inputs";
import { selectBaseClassNames } from "../PaziaSelect/styles";

export interface IDropdownOption {
  label: string;
  value: string | number;
}
export interface AsyncDropdownProps {
  name: string;
  onChange: (event: any) => void;
  value?: any;
  required?: boolean;
  label?: string;
  className?: string;
  disabled?: boolean;
  isClearable?: boolean;
  isMulti?: boolean;
  key?: React.Key;
  loadOnRender?: boolean;
  loadOptions: (inputValue: string) => Promise<IDropdownOption[]>;
}

export const AsyncDropdown = ({
  label,
  name,
  value,
  onChange,
  isClearable = true,
  className,
  disabled,
  isMulti,
  key,
  loadOnRender,
  loadOptions,
  required,
}: AsyncDropdownProps): JSX.Element => {
  const [options, setOptions] = React.useState<IDropdownOption[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const onFocusHandler = async () => {
    setIsLoading(true);
    const options = await loadOptions("");
    setOptions(options);
    setIsLoading(false);
  };

  useEffect(() => {
    if (loadOnRender) onFocusHandler();
  }, []);

  const resolveValue = () => {
    if (!value) return null;
    if (isMulti && Array.isArray(value)) {
      return options.filter((x) => value.includes(x.value));
    } else {
      return options.find((x) => x.value == value);
    }
  };

  return (
    <div className={`relative inline-flex w-full ${label ? "flex-col" : ""} ${className ?? ""}`}>
      <InputLabel label={label} required={required} name={name} />
      <Select
        isSearchable={true}
        key={key}
        onChange={onChange}
        value={resolveValue()}
        name={name}
        isMulti={isMulti}
        isDisabled={disabled}
        className="w-full"
        defaultValue={value}
        noOptionsMessage={() => "Brak wyników"}
        placeholder="Wybierz..."
        isLoading={isLoading}
        classNames={selectBaseClassNames(disabled)}
        isClearable={isClearable}
        options={options}
        onFocus={onFocusHandler}
      />
    </div>
  );
};
